import { Component } from '@theme/component';
import { VariantSelectedEvent, VariantUpdateEvent } from '@theme/events';
import { yieldToMainThread } from '@theme/utilities';

export default class Hub47VariantPicker extends Component {
    
    connectedCallback() {
        super.connectedCallback();
        this.onCallback = false;
        const form = /** @type {HTMLFormElement[]} */ (this.refs.form || null);
        if (form) {
            addEventListener('change', this.handleFormOnChange);
        }
        this.fieldsets = document.querySelectorAll('variant-picker fieldset');
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    handleFormOnChange = (event) => {
        if (this.onCallback) {
            return;
        }
        this.onCallback = true;
        const variantId = event.target.dataset.variantId;
        const variantOptions = JSON.parse(event.target.dataset.variantOptions);
        console.log(variantOptions);
        for (const [index, val] of variantOptions.entries()) {
            const radios = this.fieldsets[index].querySelectorAll("input[type=radio]");
            for (const r of radios) {
                if (val == r.value) {
                    console.log(`found [${index}]`);
                    r.checked = true;
                    r.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }
        this.onCallback = false;
    };
};

if (!customElements.get('hub47-variant-picker')) {
  customElements.define('hub47-variant-picker', Hub47VariantPicker);
}

